// extracted by mini-css-extract-plugin
export default {"content":"EmptyDashboard_content__ljVxd","subHeading":"EmptyDashboard_subHeading__wNUSO","iconContainer":"EmptyDashboard_iconContainer__QwyIr"};